import type { RootState } from '@/store/root-reducer';

const selectState = (state: RootState) => state.deactivatedProfiles;

export const selectRows = (state: RootState) => selectState(state).rows;
export const selectTotal = (state: RootState) => selectState(state).total;
export const selectLoading = (state: RootState) => selectState(state).loading;
export const selectError = (state: RootState) => selectState(state).error;
export const selectPage = (state: RootState) => selectState(state).page;
export const selectPageSize = (state: RootState) => selectState(state).pageSize;
export const selectFilters = (state: RootState) => selectState(state).filters;
export const selectRestore = (state: RootState) => selectState(state).restore;
export const selectStats = (state: RootState) => selectState(state).stats;
export const selectScan = (state: RootState) => selectState(state).scan;
export const selectPreview = (state: RootState) => selectState(state).preview;
export const selectKeywords = (state: RootState) => selectState(state).keywords;
export const selectProfileTypes = (state: RootState) => selectState(state).profileTypes;
export const selectKeywordsMutating = (state: RootState) => selectState(state).keywords.mutating;
export const selectReactivated = (state: RootState) => selectState(state).reactivated;
